import { Box } from "../layout/box.ts";
import { BaseElement } from "./baseElement.ts";
import type { jsPDF } from "jspdf";

export class Text2D extends BaseElement {
	kind = "text2d" as const;
	color: string;
	fontFamily: string;
	fontWeight: string;
	fontSize: number;
	text: string;
	maxWidth: number = Number.MAX_VALUE;
	lineHeight = 0;

	constructor(
		box: Box,
		id: string,
		fontFamily: string,
		fontWeight: string,
		fontSize: number,
		text: string,
		color: string
	) {
		super(box, id);
		this.fontFamily = fontFamily;
		this.fontWeight = fontWeight;
		this.fontSize = fontSize;
		this.color = color;
		this.text = text;
	}

	async calculate(jsPdf: jsPDF) {
		if (this.maxWidth < this.box.size.width) {
			this.box.size.width = this.maxWidth;
		}
		jsPdf.setFont(this.fontFamily, this.fontWeight);
		jsPdf.setFontSize(this.fontSize);
		const lines = jsPdf.splitTextToSize(this.text, this.box.size.width);
		let fontHeight = jsPdf.getFontSize() / jsPdf.internal.scaleFactor;
		fontHeight += this.lineHeight;
		this.box.size.height = lines.length * fontHeight;
	}

	async draw(pdfDocument: jsPDF): Promise<void> {
		pdfDocument.setTextColor(this.color);
		pdfDocument.setFont(this.fontFamily, this.fontWeight);
		pdfDocument.setFontSize(this.fontSize);
		const box = this.box.getBoundingBox();
		const lines = pdfDocument.splitTextToSize(this.text, this.box.size.width);
		let textSize = pdfDocument.getFontSize() / pdfDocument.internal.scaleFactor;
		textSize += this.lineHeight;
		if (lines.length > 1) {
			for (const [index, line] of lines.entries()) {
				pdfDocument.text(line, box.x, box.y + textSize * index, { baseline: "top" });
			}
		} else {
			pdfDocument.text(this.text, box.x, box.y, { baseline: "top" });
		}
	}
}
